import React, { useContext, useState } from 'react';

import { Form, Select, DatePicker, Checkbox, InputNumber, Row, Col, Radio, Card, TimePicker, ConfigProvider, Typography, Tag } from 'antd';
import { InteractionOutlined } from '@ant-design/icons';
import dayjs from "dayjs";

import { CreateOperationDataContext } from '../../../helpers/Context';
import DiRangePicker from '../../DiRangePicker';

import itIT from 'antd/lib/locale/it_IT';
import { daysOfWeek, monthsOfYear, weeksOfMonth } from '../../../helpers/DateUtils';

const { Option } = Select;

export default function MarketingOperationCreateSchedule({setRepeatFrequency, repeatFrequency, setSelectedDays, selectedDays}) {
   
   const { form } = useContext(CreateOperationDataContext);

   const formName = "schedule";

   const handleFrequencyChange = (value) => {
      
      setRepeatFrequency(value);
      setSelectedDays([]);

      setTimeout(() => {
         form.validateFields();
      }, 200);
   };
   
   return (
         <>
            
         <Card className='mb-20'>
            
            <Tag color='green' className='mb-20 p-20 flex gap-10 flex-wrap align-center'>
               <img
                  alt="Insight Scheduling"
                  src="/di-schedule.svg"
                  height={"80px"}
               />
               <Typography className='fs-15 text-wrap'>In quest'area definirai la cadenza in cui questa operazione si ripeterà sui pubblici che hai scelto. È possibile inviarla istantaneamente o definire una cadenza: giornaliera, settimanale, mensile o annuale. È obbligatorio definire l'orario di partenza dell'operazione ed il periodo effettivo per cui questa operazione si ripeterà.</Typography>
            </Tag>

               {/* -------------— Frequenza di ripetizione -------------— */}
               <Form.Item
                  name={[formName, "schedule_type"]}
                  className='m-0'
                  initialValue={"immediate"}
                  label={
                     <span className='flex gap-5'><InteractionOutlined />Scegli quando inviare </span>
                  }
               >
                  <Select className='min-w-150' value={repeatFrequency} onChange={handleFrequencyChange}>
                     <Option value="immediate">Invia ora</Option>
                     <Option value="daily">Ogni giorno</Option>
                     <Option value="weekly">Ogni settimana</Option>
                     <Option value="monthly_specific_day">Ogni mese (in un giorno specifico)</Option>
                     <Option value="monthly_specific_day_week">Ogni mese (indicando la settimana del mese)</Option>
                     <Option value="yearly">Ogni anno</Option>
                  </Select>
               </Form.Item>
               {/* -------------— Frequenza di ripetizione -------------— */}
      
               {/* -------------— Selezione giorni specifici della settimana per "Ogni settimana" -------------— */}
               {repeatFrequency === 'weekly' && (
                  <Form.Item
                     rules={[
                        {
                           required: true,
                           message: "Per favore, seleziona almeno un giorno della settimana!",
                        },
                     ]}
                     name={[formName, "days_of_week"]}
                     label="Giorni della settimana"
                     className='mb-0 mt-20'
                  >
                     <Checkbox.Group value={selectedDays} onChange={setSelectedDays}>
                        <Row gutter={[10,10]}>
                           {daysOfWeek.map((day, index) => (
                              <Col key={index}>
                                 <Checkbox value={index}>{day}</Checkbox>
                              </Col>
                           ))}
                        </Row>
                     </Checkbox.Group>
                  </Form.Item>
               )}
               {/* -------------— Selezione giorni specifici della settimana per "Ogni settimana" -------------— */}
      
               {/* ------------- Opzioni per la ripetizione mensile ------------- */}
                  {/* Giorno specifico del mese */}
                  {repeatFrequency === 'monthly_specific_day' && (
                     <Form.Item
                        name={[formName, "monthly_day_number"]}
                        className='mb-0 mt-20'
                        label="Giorno del mese"
                        rules={[
                           {
                              required: true,
                              message: "Per favore, seleziona un giorno del mese!",
                           },
                        ]}
                     >
                        <InputNumber  min={1} max={31} placeholder="Es. 15" />
                     </Form.Item>
                  )}
                  {/* Giorno specifico del mese */}
   
                  {/* Selezione di settimana e giorno per il mese */}
                  {repeatFrequency === 'monthly_specific_day_week' && (
                     <Row gutter={8}>
                        <Col span={12}>
                           <Form.Item 
                              rules={[{ required: true, message: 'Seleziona una settimana' }]}
                              name={[formName, "monthly_week_number"]}
                              className='mb-0 mt-20'
                              label="Settimana" 
                           >
                              <Select className='min-w-150' placeholder="Seleziona una settimana">
                                 {weeksOfMonth.map((week, index) => (
                                    <Option key={index} value={index + 1}>
                                       {week}
                                    </Option>
                                 ))}
                              </Select>
                           </Form.Item>
                        </Col>
                        <Col span={12}>
                           <Form.Item 
                              rules={[{ required: true, message: 'Seleziona un giorno della settimana' }]}
                              label="Giorno della settimana" 
                              className='mb-0 mt-20'
                              name={[formName, "monthly_day_of_week"]}
                           >
                              <Select className='min-w-150' placeholder="Seleziona un giorno">
                                 {daysOfWeek.map((day, index) => (
                                    <Option key={index} value={index}>
                                       {day}
                                    </Option>
                                 ))}
                              </Select>
                           </Form.Item>
                        </Col>
                     </Row>
                  )}
                  {/* Selezione di settimana e giorno per il mese */}
               {/* ------------- Opzioni per la ripetizione mensile ------------- */}
      
               {/* ------------- Giorno specifico dell'anno per "Ogni anno" ------------- */}
               {repeatFrequency === 'yearly' && (
                  <div className='flex flex-wrap gap-10 mt-20'>
                     <Form.Item
                        rules={[
                           {
                              required: true,
                              message: "Per favore, seleziona il giorno del mese per la ripetizione annuale!",
                           },
                        ]}
                        name={[formName, "yearly_day"]}
                        className='mb-0'
                        label="Giorno"
                     >
                        <InputNumber  min={1} max={31} placeholder="Es. 15" />
                     </Form.Item>
                  
                        <Form.Item
                           rules={[
                              {
                                 required: true,
                                 message: "Per favore, seleziona il mese dell'anno per la ripetizione annuale!",
                              },
                           ]}
                           name={[formName, "yearly_month"]}
                           className='mb-0'
                           label="Mese"
                        >
                           <Select className='min-w-150' placeholder="Seleziona il mese" required>
                           {monthsOfYear.map((month, index) => (
                              <Option key={index + 1} value={index + 1}>
                                 {month}
                              </Option>
                           ))}
                        </Select>
                     </Form.Item>
                 </div>
               )}
               {/* ------------- Giorno specifico dell'anno per "Ogni anno" ------------- */}
            </Card>
   
            {/* ------------- Intervallo di date ------------- */}
            {repeatFrequency !== 'immediate' &&
               <Card>
                 <div className='flex gap-10 flex-wrap align-center'>
                     <ConfigProvider locale={itIT}>
                     
                        <Form.Item
                           name={[formName, "execution_times"]}
                           label="Orario ricorrenza"
                           rules={[
                              {
                                 required: true,
                                 message: "Per favore, seleziona un orario di schedule!",
                              },
                           ]}
                        >
                           <TimePicker
                              defaultOpenValue={dayjs('00:00:00', 'HH:mm:ss')}
                              className='w-100'
                           />
                        </Form.Item>
                  
                        <Form.Item
                           name={[formName, "full_date"]}
                           //inserire qui i preset di tempo futuri
                           label={
                              <div className='flex gap-5 align-center justify-center'>
                                 Range di attivazione ricorrenza
                              </div>
                           }
                           rules={[
                              {
                                 required: true,
                                 message: "Per favore, seleziona una data per cui l'operazione continuerà a lavorare!",
                              },
                           ]}
                        >
                           <DiRangePicker
                              showFuturePresets
                              enableAllDate
                              hideTime
                              outlined
                           />
                        </Form.Item>
                    
                     </ConfigProvider>
                 </div>
               </Card>
            }
            {/* ------------- Intervallo di date ------------- */}
   
         </>
   );
}